import { exportToXlsx, exportToXlsxMultiSheet } from './exporters/xlsxExporter';
import { exportToZip } from './exporters/zipExporter';

/**
 * 다운로드 서비스
 * @param {Object} config - 캠페인 설정 객체
 * @param {Array} selectedRows - 선택된 행 배열
 * @param {Array} allRows - 전체 행 배열
 */
export async function download(config, selectedRows = [], allRows = []) {
  const downloadConfig = config.download;
  if (!downloadConfig) {
    throw new Error('다운로드 설정이 config에 정의되지 않았습니다.');
  }

  // 선택 항목 우선, 없으면 전체 항목 사용
  const rowsToDownload = selectedRows.length > 0 ? selectedRows : allRows;

  if (rowsToDownload.length === 0) {
    alert('다운로드할 데이터가 없습니다.');
    return;
  }

  try {
    if (downloadConfig.type === 'xlsx') {
      // 단일 시트 XLSX
      if (downloadConfig.multiSheet) {
        // 다중 시트 지원
        exportToXlsxMultiSheet(
          downloadConfig.sheets || [],
          downloadConfig.fileName || 'download.xlsx'
        );
      } else {
        // 단일 시트
        exportToXlsx(
          rowsToDownload,
          downloadConfig.fileName || 'download.xlsx',
          downloadConfig.sheetName || 'Sheet1',
          downloadConfig.transformRow,
          downloadConfig.headers || null
        );
      }
    } else if (downloadConfig.type === 'zip') {
      // ZIP 다운로드
      await exportToZip(
        rowsToDownload,
        downloadConfig.fileName || 'download.zip',
        downloadConfig.groupBy,
        downloadConfig.assets,
        downloadConfig.urlTextBuilder,
        downloadConfig.folderNameBuilder
      );
    } else {
      throw new Error(`지원하지 않는 다운로드 타입: ${downloadConfig.type}`);
    }
  } catch (error) {
    console.error('다운로드 오류:', error);
    alert(error.message || '다운로드 중 오류가 발생했습니다.');
    throw error;
  }
}

